import { createBrowserRouter, Navigate } from 'react-router';
import { Welcome } from './pages/Welcome';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import { ProjectList } from './pages/Projects/ProjectList';
import { ProjectCreate } from './pages/Projects/ProjectCreate';
import { ProjectDetail } from './pages/Projects/ProjectDetail';
import { PodcastSearch } from './pages/Podcasts/PodcastSearch';
import { PopularPodcasts } from './pages/Podcasts/PopularPodcasts';
import { VocabularyList } from './pages/Vocabulary/VocabularyList';
import { VocabularyReview } from './pages/Vocabulary/VocabularyReview';
import { JournalsPage } from './pages/Journals/JournalsPage';
import { JournalEntriesPage } from './pages/Journals/JournalEntriesPage';
import { JournalEditorPage } from './pages/Journals/JournalEditorPage';
import { ProjectPlayer } from './pages/Player/ProjectPlayer';
import { VideoPlayer } from './pages/Projects/VideoPlayer/VideoPlayer';
import { Reports } from './pages/Reports/Reports';
import { StoryTimePage } from './pages/StoryTime/StoryTimePage';
import { Settings } from './pages/Settings';
import { Subscription } from './pages/Subscription';
import { NotFound } from './pages/NotFound';
import { Help } from './pages/Help';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { DmcaPolicy } from './pages/DmcaPolicy';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { AuthorizedRoute } from './components/auth/AuthorizedRoute';
import { Layout } from './components/layout/Layout';
import { ROUTES } from './config/constants';

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <Welcome />,
  },
  {
    path: ROUTES.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTES.REGISTER,
    element: <Register />,
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: <ResetPassword />,
  },
  {
    path: ROUTES.HELP,
    element: <Help />,
  },
  {
    path: ROUTES.PRIVACY,
    element: <PrivacyPolicy />,
  },
  {
    path: ROUTES.TERMS,
    element: <TermsOfService />,
  },
  {
    path: ROUTES.DMCA,
    element: <DmcaPolicy />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: ROUTES.DASHBOARD,
            element: <Dashboard />,
          },
          {
            path: ROUTES.PROJECTS,
            element: <ProjectList />,
          },
          {
            path: `${ROUTES.PROJECTS}/new`,
            element: <ProjectCreate />,
          },
          {
            path: ROUTES.PROJECT_DETAIL,
            element: (
              <AuthorizedRoute resourceType="project" resourceIdParam="id">
                <ProjectDetail />
              </AuthorizedRoute>
            ),
          },
          {
            path: ROUTES.VIDEO_PLAYER,
            element: (
              <AuthorizedRoute resourceType="project" resourceIdParam="projectId">
                <VideoPlayer />
              </AuthorizedRoute>
            ),
          },
          {
            path: '/podcasts/search',
            element: <PodcastSearch />,
          },
          {
            path: '/podcasts/popular',
            element: <PopularPodcasts />,
          },
          {
            path: '/podcasts',
            element: <Navigate to="/podcasts/search" replace />,
          },
          {
            path: '/player/:projectId/podcast/:podcastId',
            element: (
              <AuthorizedRoute resourceType="project" resourceIdParam="projectId">
                <ProjectPlayer />
              </AuthorizedRoute>
            ),
          },
          {
            path: '/player/:projectId/:episodeId',
            element: (
              <AuthorizedRoute resourceType="episode" resourceIdParam="episodeId" projectIdParam="projectId">
                <ProjectPlayer />
              </AuthorizedRoute>
            ),
          },
          {
            path: ROUTES.PLAYER,
            element: <Navigate to={ROUTES.PROJECTS} replace />,
          },
          {
            path: ROUTES.VOCABULARY,
            element: <VocabularyList />,
          },
          {
            path: ROUTES.VOCABULARY_REVIEW,
            element: <VocabularyReview />,
          },
          {
            path: ROUTES.JOURNALS,
            element: <JournalsPage />,
          },
          {
            path: ROUTES.JOURNAL_DETAIL,
            element: <JournalEntriesPage />,
          },
          {
            path: ROUTES.JOURNAL_ENTRY_NEW,
            element: <JournalEditorPage />,
          },
          {
            path: ROUTES.JOURNAL_ENTRY,
            element: <JournalEditorPage />,
          },
          {
            path: ROUTES.REPORTS,
            element: <Reports />,
          },
          {
            path: ROUTES.STORYTIME,
            element: <StoryTimePage />,
          },
          {
            path: ROUTES.SETTINGS,
            element: <Settings />,
          },
          {
            path: ROUTES.SUBSCRIPTION,
            element: <Subscription />,
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
]);
